module.exports = __webpack_public_path__ + "img/join1-2.d45860a3.jpg";